<template>
	<div>
		<e-select
            v-model="planning_selected"
            track-by="taskplanning_id"
            label="taskplanning_label"
			:placeholder="$t('task_planning.select_planning')"
            :options="all_planning"
            :searchable="true"
            :allow-empty="false"
            :show-labels="false"
            :group-select="false"
            :loading="loading_all_planning"
            @input="goToLoadPlanning"
        />

        <LoadingSpinner v-if="loading_planning" class="col-12" />
        <div v-if="!loading_planning && planning_selected">
        	<div class="m-0 mt-2">
				<table class="table b-table table-striped table-hover table-borderless table-variante table-task">
					<thead class="sticky">
						<tr class="b-table-details">
							<th>
								<button class="btn btn-secondary" @click="goPrev"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /></button>
								<button class="btn btn-secondary" @click="goNext"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /></button>
							</th>
							<th v-for="day in dates_to_show" class="border-left border-right border-bottom text-center" :key="day">
								{{ getDateLabel(day) }}	{{ formatDate(day, false) }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="horse in planning.horses" :key="horse.horse.horse_id" class="b-table-details">
							<td><router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: horse.horse.horse_id }}">{{ horse.horse.horse_nom }}</router-link></td>
								<td v-for="day in dates_to_show" class="border-left border-right border-bottom text-center p-0" :key="day">
									<div class="text-center justify-content-center align-items-center py-2">
									<button class="btn btn-secondary" @click="add(horse.horse, day)"><font-awesome-icon :icon="['far', 'plus']" /></button>
								</div>
								<template v-if="horse.task[day].length">
									<div v-for="task in horse.task[day]" @click="edit(task, horse.horse, day)" class="border-top" role="button" :style="{'background': task.acte && task.acte.actes_actesstatut ? 'green' : 'unset' }" :key="task.task_id">
										<b-avatar
											v-if="task.contact"
											size="3em"
											:style="'color: white;background-color:'+task.contact.contact_color"
										>
											{{ task.contact.contact_abbreviation }}
										</b-avatar>
										<span class="ml-2" v-if="task.acte_type">{{ task.acte_type.actestype_label }}</span>
									</div>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
        </div>
	</div>
</template>

<script type="text/javascript">
	import TaskPlanning from "@/mixins/TaskPlanning.js"
	import _union from 'lodash/union'
	import _cloneDeep from 'lodash/cloneDeep'
    import Shutter from '@/mixins/Shutter.js'
	import ShutterAct from "@/mixins/shutters-manager/Acts.js"

	export default {
		name: 'TaskPlanning',
		mixins: [TaskPlanning, Shutter, ShutterAct],
		data () {
			return {
				loading_all_planning: false,
				loading_planning: false,
				all_planning: [],
				planning_selected: null,
				planning: {
					days: {},
					horses: {}
				},
				dates_to_show: [],
				horse_selected: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading_all_planning = true
				this.all_planning = await this.getAllTaskPlanning(true)
				this.loading_all_planning = false

				let today = new Date()
				let tomorrow = new Date()
				tomorrow.setDate(tomorrow.getDate() + 1)

				this.dates_to_show = [today.toDateInputValue(), tomorrow.toDateInputValue()]
			},

			goToLoadPlanning() {
				this.planning = {
					days: {},
					horses: {}
				}
				let start = new Date()
				start.setDate(start.getDate() - 5)
				let end = new Date()
				end.setDate(end.getDate() + 5)
				this.loadPlanning(start.toDateInputValue(), end.toDateInputValue())
			},

			async loadPlanning(start, end) {
				this.loading_planning = true
				const planning = await this.getTaskPlanning(this.planning_selected.taskplanning_id, start, end)

				const days = _union(this.planning.days, planning.days)
				this.planning.days = days.sort((a,b) => {
					if(new Date(a).getTime() > new Date(b).getTime()) {
						return 1
					}
					else {
						return -1
					}
				})

				for(let id in planning.horses) {
					if(!Object.prototype.hasOwnProperty.call(this.planning.horses, id)) {
						this.planning.horses[id] = _cloneDeep(planning.horses[id])
					}
					else {
						let days = _cloneDeep(this.planning.horses[id].task)
						for(let day in planning.horses[id].task) {
							if(!Object.prototype.hasOwnProperty.call(days, day)) {
								days[day] = _cloneDeep(planning.horses[id].task[day])
							}
						}
						this.planning.horses[id].task = days
					}
				}

				this.loading_planning = false
			},

			getDateLabel(date) {
				return this.getTrad("monte.jours."+new Date(date).getDay())
			},

			async goPrev() {
				let current = this.dates_to_show[0]
				let current_in_tab = this.planning.days.indexOf(current)

				if(current_in_tab == 1) {
					let start = new Date(current)
					start.setDate(start.getDate() - 7)
					let end = new Date(current)
					end.setDate(end.getDate() - 2)
					await this.loadPlanning(start.toDateInputValue(), end.toDateInputValue())
				}

				current_in_tab = this.planning.days.indexOf(current)

				let start = this.planning.days[current_in_tab-1]
				let end = this.planning.days[current_in_tab]

				this.dates_to_show = [start, end]
			},
			
			async goNext() {
				let current = this.dates_to_show[0]
				let current_in_tab = this.planning.days.indexOf(current)

				if(current_in_tab == this.planning.days.length - 2) {
					let start = new Date(current)
					start.setDate(start.getDate() + 2)
					let end = new Date(current)
					end.setDate(end.getDate() + 7)
					await this.loadPlanning(start.toDateInputValue(), end.toDateInputValue())
				}

				current_in_tab = this.planning.days.indexOf(current)

				let start = this.planning.days[current_in_tab+1]
				let end = this.planning.days[current_in_tab+2]

				this.dates_to_show = [start, end]
			},

			add(horse, day) {
                this.setupAddTaskPlanning(horse, day, this.planning_selected, async (next) => {
                	this.shutterPanel().close('task-planning-add')

                	if(next) {
                		this.next(horse, day)
	                }
	                else {
	                	this.goToLoadPlanning()
	                }
                })
			},

			edit(task, horse, day) {
				this.setupEditTaskPlanning(task, horse, this.planning_selected, async (next) => {
                	this.shutterPanel().close('task-planning-add')

                	if(next) {
                		this.next(horse, day)
                	}
	                else {
	                	this.goToLoadPlanning()
	                }
                })
			},

			next(horse, day) {
				const horse_keys = Object.keys(this.planning.horses)
            	const horse_idx = horse_keys.indexOf(horse.horse_id.toString())

            	// si je suis arrivé au dernier je ne fais rien
            	if(horse_idx == horse_keys.length - 1) {
            		this.goToLoadPlanning()
            		return true
            	}
            	const horse_next_id = horse_keys[horse_idx+1]
            	if(this.planning.horses[horse_next_id].task[day].length > 0) {
            		this.edit(this.planning.horses[horse_next_id].task[day][0], this.planning.horses[horse_next_id].horse, day)
            	}
            	else {
            		this.add(this.planning.horses[horse_next_id].horse, day)
            	}
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>